import { Component, OnInit, NgZone } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { SaveMessageComponent } from '../../directive/save-message/save-message.component';
import { MatDialog } from '@angular/material';
import * as _ from "lodash";
import { CategoriesService } from '../../_services/categories.service';
import { ApiService } from '../../_services/api.service';
import { DataSource } from '@angular/cdk/table';
import { AngularFirestore } from 'angularfire2/firestore';
import { map } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-welcome-footer',
  templateUrl: './welcome-footer.component.html',
  styleUrls: ['./welcome-footer.component.css']
})
export class WelcomeFooterComponent implements OnInit {
  brandList = [];
  brandList2 = [];
  likelyList: Observable<any[]>;
  subs = new Subscription();
  likelyList2 = [];
  categories = [];
  categories2 = [];
  brands = [
    {
      name: 'Garanti Bankası',
      uniqueName: 'garantibankasi'
    },
    {
      name: 'Vodafone',
      uniqueName: 'vodafone'
    },
    {
      name: 'Samsung',
      uniqueName: 'samsung'
    },
    {
      name: 'A101',
      uniqueName: 'a101'
    },
    {
      name: 'Apple',
      uniqueName: 'apple'
    },
    {
      name: 'Turkcell',
      uniqueName: 'turkcell'
    },
    {
      name: 'Superonline',
      uniqueName: 'superonline'
    },
  ]

  constructor(
    private zone: NgZone,
    private dialog: MatDialog,
    private http: Http,
    private afs: AngularFirestore,
    private apiService: ApiService,
    private categoriesService: CategoriesService) {

    this.likelyList = this.afs.collection('weeklyPosts', ref => ref.where('order', '==', 1)).snapshotChanges().pipe(map(actions => {
      return actions.map(a => {
        return {
          id: a.payload.doc.id,
          hashtagList: _.orderBy(Object.values(a.payload.doc.data()['hashtags']), 'total', 'desc').slice(0, 7),
          ...a.payload.doc.data()
        }
      });
    }));

  }

  ngOnInit() {




    this.categoriesService.categories.forEach(a => {

      if (a.name !== 'Ev, Yaşam & Ofis' && a.name !== 'Sağlık, Güzellik & Kozmetik' && a.name !== 'Spor & Aktif Yaşam') {
        this.categories.push({
          name: a.name,
          uniqueName: a.uniqueName
        })
      }
    })
    this.categories = this.categories.slice(0, 7)




  }
  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  getIpAdress(): Observable<any> {
    return this.http.get("https://api.bigadvice.com/helper/ip")
      .map(data => data.json());
  }

  joinUs(email) {
    if (email.replace(/\s/g, '') == '') {
      this.dialog.open(SaveMessageComponent, {
        width: '400px',
        data: {
          message: "E-posta adresini yazmalısın!",
          type: "update"
        }
      });
      return;
    }
    this.subs = this.getIpAdress().subscribe(data => {
      this.afs.collection('newsLetter').add({
        email: email,
        modifyDate: Date.now(),
        ipAdress: data
      }).then(() => {
        this.dialog.open(SaveMessageComponent, {
          width: '400px',
          data: {
            message: "Bilgilerin iletilmiştir, teşekkürler.",
            type: "update"
          }
        });
      });
    });

  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/welcome-page/welcome-footer/welcome-footer.component.ts